import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { style: {"line-height":"20px"} }
const _hoisted_3 = { style: {"margin-top":"10px","line-height":"20px"} }
const _hoisted_4 = { style: {"margin-top":"10px","line-height":"20px"} }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "templateExampleTips abs" }
const _hoisted_7 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/zozotown/template5030_final.png",
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/Client/zozotown/template4080_final.png",
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  class: "tagLogo"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_627_8427)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.00047 0.66748C2.15998 0.66748 0.667969 2.15949 0.667969 3.99998C0.667969 5.84047 2.15998 7.33248 4.00047 7.33248C5.84096 7.33248 7.33297 5.84047 7.33297 3.99998C7.33297 2.15949 5.84096 0.66748 4.00047 0.66748Z",
    fill: "#505762"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.17829 3.29291C5.30846 3.16274 5.30846 2.95168 5.17829 2.82151C5.04811 2.69133 4.83706 2.69133 4.70688 2.82151L3.9998 3.52859L3.29272 2.82151C3.16254 2.69133 2.95149 2.69133 2.82131 2.82151C2.69114 2.95168 2.69114 3.16274 2.82131 3.29291L3.5284 3.99999L2.82126 4.70712C2.69109 4.8373 2.69109 5.04835 2.82126 5.17853C2.95144 5.3087 3.16249 5.3087 3.29267 5.17853L3.9998 4.4714L4.70693 5.17853C4.83711 5.3087 5.04816 5.3087 5.17834 5.17853C5.30851 5.04835 5.30851 4.8373 5.17834 4.70712L4.4712 3.99999L5.17829 3.29291Z",
    fill: "white"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_627_8427" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "8",
      height: "8",
      fill: "white"
    })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import UploadFile from '@/components/common/UploadFilePDF.vue'
import { ElMessage } from 'element-plus'
import { hiprint, defaultElementTypeProvider, disAutoConnect } from 'vue-plugin-hiprint'
import { fields, optionsFormat } from './printTemplateData'
import type { FormInstance } from 'element-plus'
import { saveTemplate } from '@/apis/order'

enum PAPER{
  type1 = 1,
  type2 = 2
}

type optionsItem = {
  textType?: string // 文字 二维码type
  width?: number,
  height?: number,
  top?: number,
  left?: number,
  title?: string, // title
  textAlign?: string, // textAlign
  field?: string, // 变量字段key
  testData?: string // 模板中展示的模拟数据
}
type printElementItem = {
  options: optionsItem
}

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'printOptions', 'templateList', 'zozotownConfig'],
  emits: ['update:visible', 'changePaperTemplate', 'updateTemplate', 'updateTagLogo'],
  setup(__props, { emit }) {

const props = __props
disAutoConnect()




const cancel = () => {
  emit('update:visible', false)
}
const formRef = ref<FormInstance>()

const commit = () => {
  // hiprintTemplate.value.print({});
  const options = hiprintTemplate.value.getPanel().printElements.map((v) => {
    return v.options
  })
  if (!options || !options.length) {
    ElMessage.warning(t('模板不能为空'))
    return
  }
  saveTemplate({
    size: targetPaper.value,
    templateJson: options,
    type: 4
  }).then(() => {
    ElMessage.success(t('已完成'))
    emit('updateTemplate')
    emit('update:visible', false)
  })
}

const paperSize = {
  type1: {
    width: 40,
    height: 80
  },
  type2: {
    width: 50,
    height: 30
  }
} as const
const targetPaper = ref(1)
const printElements = ref<printElementItem[]>([])
const hiprintTemplate = ref()
const templateDesignDiv = ref()
const panel = ref()
const temp = ref()
const dialogOpened = () => {
  temp.value = props.printOptions ?? props.templateList[0]
  printInit()
}
const printInit = () => {
  templateDesignDiv.value && (templateDesignDiv.value.innerHTML = '')

  const sizeCache = temp.value.size === 1 ? paperSize.type1 : paperSize.type2
  targetPaper.value = temp.value.size
  hiprint.init({})
  hiprintTemplate.value = new hiprint.PrintTemplate()
  panel.value = hiprintTemplate.value.addPrintPanel({ width: sizeCache.width + 1, height: sizeCache.height + 1 })
  const targetTemp = temp.value.templateJson
  targetTemp.forEach((v:any) => {
    const data = {
      ...v
    }
    panel.value.addPrintText({ options: data })
  })
  hiprintTemplate.value.design('#templateDesignDiv')
  setLogoSize()
}
const panelUpdate = () => {
  templateDesignDiv.value && (templateDesignDiv.value.innerHTML = '')
  hiprintTemplate.value.design('#templateDesignDiv')
  setLogoSize()
}

const setLogoSize = () => {
  setTimeout(() => {
    const paperNumberEl = hiprintTemplate.value.container[0]

    // 隐藏自带的页码 不知道为什么配置项设置了没用
    paperNumberEl.querySelectorAll('.hiprint-paperNumber').forEach((e:any) => {
      e.style.display = 'none'
    })

    // 取消他自带的双击编辑功能
    const els = paperNumberEl.querySelectorAll('.hiprint-printElement')
    els.forEach((v: any) => {
      const keys = Object.keys(v)
      keys.forEach(y => {
        if (y.includes('jQuery')) {
          if (v[y]?.events?.dblclick) {
            v[y].events.dblclick = () => {}
          }
        }
      })
    })

    hiprintTemplate.value.getPanel().printElements.forEach((v) => {
      // 变量标红
      if (v.options?.key) {
        const targetEl = hiprintTemplate.value.getElementByName(v.options.name)[0]?.designTarget[0]
        if (targetEl) {
          targetEl.querySelectorAll('.hiprint-printElement-text-content').forEach((e:any) => {
            e.style.border = '1px dashed red'
          })
        }
      }
      // 控制LOGO那个按钮能不能调整大小
      if (v.options.name === t('LOGO')) {
        const targetEl = hiprintTemplate.value.getElementByName(v.options.name)[0]?.designTarget[0]
        targetEl.querySelectorAll('.resizebtn').forEach((e:any) => {
          e.style.display = 'none'
        })
      }
    })

    // 控制LOGO那个按钮能不能调整大小
    // const logoEl = hiprintTemplate.value.getElementByName(t(''))[0]?.designTarget[0] ?? null
    // if (!logoEl) {
    //   return
    // }
    // logoEl.querySelectorAll('.resizebtn').forEach((e:any) => {
    //   e.style.display = 'none'
    // })
  }, 0)
}

const addVisible = ref(false)
const form = ref({
  templateName: '',
  templateType: 'text',
  templateData: '',
  templateLogo: ''
})
form.value.templateLogo = props.zozotownConfig?.tagLogo ?? ''
const formRule = {
  templateName: [{ required: true, message: t('必填') }],
  templateType: [{ required: true, message: t('必填') }],
  templateData: [{ required: true, message: t('必填') }],
  templateLogo: [{ required: true, message: t('必填') }]
}
const submitKey = () => {
  formRef.value?.validate((valid) => {
    if (valid) {
      const option = optionsFormat(form.value)
      const panelOptions = hiprintTemplate.value.getPanel().printElements.map(v => {
        return {
          ...v.options
        }
      })
      if (option?.name_zh === 'LOGO') {
        // 没有就加一个
        if (panelOptions.every((v:any) => v.name_zh !== 'LOGO')) {
          panel.value.addPrintText({
            options: option
          })
        }
        emit('updateTagLogo', form.value.templateLogo)
      } else {
        if (option.key && panelOptions.some((v:any) => v.name_zh === option.name_zh)) {
          ElMessage.warning(t('重复添加'))
          return
        }
        panel.value.addPrintText({
          options: option
        })
      }
      panelUpdate()
      form.value = {
        templateName: '',
        templateType: 'text',
        templateData: '',
        templateLogo: form.value.templateLogo
      }
      addVisible.value = false
    }
  })
}

const setPaperSize = (sizeConfig:any, size:number) => {
  if (targetPaper.value === size) {
    return
  }
  if (props.printOptions && props.printOptions.size === size) {
    temp.value = props.printOptions
  } else {
    temp.value = props.templateList.filter(v => v.size === size)[0]
  }
  hiprintTemplate.value.setPaper(sizeConfig.width + 1, sizeConfig.height + 1)
  targetPaper.value = size
  printInit()
}

// logo上传
const zozotownLogo = ref()
const changeZozotownLogo = (file) => {
  form.value.templateLogo = file[0].raw.url
  zozotownLogo.value.handleClose(0)
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonDialog, {
      visible: __props.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      onOk: commit,
      onCancel: cancel,
      title: _unref(t)('编辑模板'),
      footer: true,
      width: "700px",
      top: "5vh",
      closeOnClickModal: false,
      onOpened: dialogOpened
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(`${_unref(t)('操作步骤')}：①${_unref(t)('选择纸张尺寸')}→②${_unref(t)('调整模板内容')}→③${_unref(t)('移动显示位置')}→④${_unref(t)('保存模板')}`), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('操作提示')) + "：", 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('可以通过点击删除不需要的内容，如果您想要新增内容，可点击【追加】按钮进行新增')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('红色边框的内容表示您需要通过excel进行上传，黑色边框的内容为固定文本会固定显示在商品标签纸上')), 1),
          _createVNode(_component_el_form, {
            model: form.value,
            "label-width": "130px",
            rules: formRule,
            class: "form",
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            style: {"margin-top":"20px"},
            "label-position": "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('纸张尺寸'),
                prop: "templateType",
                required: true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    type: "text",
                    class: _normalizeClass({ sizeBox: true, targetBox: targetPaper.value === 1 }),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (setPaperSize(_unref(paperSize).type1, 1)))
                  }, "40*80", 2),
                  _createElementVNode("div", {
                    type: "text",
                    class: _normalizeClass({ sizeBox: true, targetBox: targetPaper.value === 2 }),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setPaperSize(_unref(paperSize).type2, 2)))
                  }, "50*30", 2)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_el_button, {
            type: "text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("添加内容")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              id: "templateDesignDiv",
              ref: (_value, _refs) => {
                _refs['templateDesignDiv'] = _value
                templateDesignDiv.value = _value
              }
            }, null, 512),
            _createElementVNode("div", {
              class: _normalizeClass({ templateExample1: targetPaper.value === 1, templateExample2: targetPaper.value === 2})
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('示例图')), 1),
              (targetPaper.value === 2)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (targetPaper.value === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CommonDialog, {
      visible: addVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((addVisible).value = $event)),
      onOk: submitKey,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (addVisible.value = false)),
      title: _unref(t)('添加内容'),
      footer: true,
      width: "800px",
      closeOnClickModal: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form.value,
          "label-width": "80px",
          rules: formRule,
          class: "form",
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('打印内容类型'),
              prop: "templateType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.value.templateType,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.templateType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('变量')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "text2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('固定文本')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "barcode" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('条形码')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "logo" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('LOGO')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (form.value.templateType === 'text')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref(t)('字段名称'),
                  prop: "templateName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.value.templateName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.templateName) = $event)),
                      style: {"width":"250px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: i.key
                          }, [
                            (!i.hideInSelect)
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  label: i.name,
                                  value: i.key
                                }, null, 8, ["label", "value"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (form.value.templateType === 'text2')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _unref(t)('字段名称'),
                  prop: "templateData"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.templateData,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.templateData) = $event)),
                      maxlength: "20",
                      placeholder: _unref(t)('请输入'),
                      style: {"width":"200px"}
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (form.value.templateType === 'logo')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: _unref(t)('图片'),
                  prop: "templateLogo"
                }, {
                  default: _withCtx(() => [
                    (!form.value.templateLogo)
                      ? (_openBlock(), _createBlock(UploadFile, {
                          key: 0,
                          ref: (_value, _refs) => {
                            _refs['zozotownLogo'] = _value
                            zozotownLogo.value = _value
                          },
                          onChange: _cache[7] || (_cache[7] = (file) => {
                changeZozotownLogo(file);
              }
                ),
                          limit: 1,
                          limitFile: {
                accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG',
              },
                          readAuto: true,
                          bizType: "shipping",
                          style: {"margin-right":"8px"}
                        }, null, 8, ["limitFile"]))
                      : _createCommentVNode("", true),
                    (form.value.templateLogo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_el_image, {
                            src: form.value.templateLogo,
                            "preview-src-list": [form.value.templateLogo],
                            style: {"width":"100px","height":"100px"},
                            fit: "contain"
                          }, null, 8, ["src", "preview-src-list"]),
                          (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "8",
                            height: "8",
                            viewBox: "0 0 8 8",
                            fill: "none",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (form.value.templateLogo = ''))
                          }, _hoisted_12))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})